import React, { SyntheticEvent } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { Modal } from 'components/';
import { compose } from 'react-apollo';
import { AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders } from '@api/graphql/types';

interface Props {
    orders: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders[];
    type: 'reserved_order_count' | 'linked_orders';
    onClose: () => void;
}

type PropType = Props & InjectedIntlProps;

class OrdersModal extends React.Component<PropType> {

    private renderReservedOrders() {
        return this.props.orders
            .filter((order: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders) => {
                return /* order.status.code !== 'CANCELED' && */ !order.parent_order;
            })
            .map((order: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders) => {
                const subOrders = this.props.orders.filter((subOrder: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders) => {
                    return subOrder.status.code !== 'CANCELED' && subOrder.parent_order && subOrder.parent_order.id === order.id;
                }).map((subOrder: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders, index: number) => {
                    return (
                        <>
                            { index > 0 ? ', ' : ''}
                            <a key={subOrder.id} href={`/orders/${subOrder.id}`} target="_blank">{subOrder.id}</a>
                        </>
                    );
                });

                return (
                    <li key={order.id}>
                        <a href={`/orders/${order.id}`} target="_blank">{order.id}</a> ({order.shipping_postcode})
                        {subOrders.length > 0 && (
                            <>
                                &nbsp;[{this.props.intl.formatMessage({id: `module.timetable.linked_orders.title`})}: {subOrders}]
                            </>
                        )}
                    </li>
                );
            });
    }

    private renderLinkedOrders() {
        return this.props.orders
            .filter((order: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders) => {
                return /* order.status.code !== 'CANCELED' && */ order.parent_order && order.parent_order.id;
            })
            .map((order: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders) => {
                const parentOrder = this.props.orders.find((parent: AdminTimetableSlotsList_adminTimetableTimeSlots_data_orders) => {
                    return parent.status.code !== 'CANCELED' && parent.id === order.parent_order!.id;
                });

                return (
                    <li key={order.id}>
                        <a href={`/orders/${order.id}`} target="_blank">{order.id}</a> ({order.shipping_postcode})
                        {parentOrder && (
                            <>
                                &nbsp;[{this.props.intl.formatMessage({id: `module.timetable.parent_order.title`})}: <a href={`/orders/${parentOrder.id}`} target="_blank">{parentOrder.id}</a>]
                            </>
                        )}
                    </li>
                );
            });
    }

    private renderBody = () => {
        return (
            <ol className="scrollable">
                {this.props.type === 'reserved_order_count' ? this.renderReservedOrders() : this.renderLinkedOrders()}
            </ol>
        );
    }

    public render() {
        return (
            <Modal
                title={this.props.intl.formatMessage({id: `module.timetable.${this.props.type}.modal`})}
                visible={true}
                onClose={(e: SyntheticEvent) => {
                    this.props.onClose();
                }}
                renderBody={this.renderBody}
            />
        );
    }
}

export default compose(
    injectIntl,
)(OrdersModal);



// WEBPACK FOOTER //
// ./src/modules/Timetable/components/OrdersModal.tsx